import { SubscriptionLike as ISubscription } from 'rxjs';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GlobalConfig, ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { VideosService } from '../../videos/videos.service';

import { APP_SETTINGS } from '@services';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { NoiseCatalogService } from '../noise-catalog.service';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NoiseCatalogShareContentComponent } from '../../noise-catalog-share-content/noise-catalog-share-content.component';
import { HighlightSearchPipe } from '../../../shared/pipes/highlight-search.pipe';

@Component({
    selector: 'app-noise-catalog-history',
    templateUrl: './noise-catalog-history.component.html',
    styleUrls: ['./noise-catalog-history.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgFor,
        RouterLink,
        NoiseCatalogShareContentComponent,
        DatePipe,
        HighlightSearchPipe,
    ],
})
export class NoiseCatalogHistoryComponent implements OnInit {

  public screenWidth: any;
  public noisecatalogList: any;
  public dateFormat: string;
  private subscription: ISubscription[];

  username: string;
  public config: GlobalConfig;

  public noisecatalogshareContentObject = {};

  public videoThumbnail = APP_SETTINGS.isMINI === 'true' ? APP_SETTINGS.miniVideoThumbnail : APP_SETTINGS.isRollsRoyce === 'true' ? APP_SETTINGS.rollsRoyceVideoThumbnail : APP_SETTINGS.videoThumbnail;
  public videoThumbnailHeight = APP_SETTINGS.videoThumbnailHeight;
  public videoThumbnailWidth = APP_SETTINGS.videoThumbnailWidth;

  @ViewChild('modalCloseButton')
  private modalCloseButtonEle: ElementRef;

  constructor(private videoService: VideosService,
    private noiseCatalogService: NoiseCatalogService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private utilityService: UtilityService,
    private toastService: ToastrService,
    private analyticsService: AnalyticsService,
    private cdr: ChangeDetectorRef
    //private toastService: ToastConfigService
  ) {
    // this.config = this.toastService.config;
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.subscription = [];
    this.username = this.authService.getUserName();
    this.dateFormat = 'yyyy-MM-dd';
    this.spinnerService.show('bmwSpinner');
    //this.username='qxz11ki';
    this.noiseCatalogService.getUserWatchHistory(this.username).subscribe(value => {
      this.spinnerService.hide('bmwSpinner');
      this.noisecatalogList = value;
      this.cdr.markForCheck();
    });
    this.subscription = [];
    this.subscription.push(this.utilityService.shareContentPopup$.subscribe(data => {
      if (typeof data === 'boolean') {
        this.modalCloseButtonEle.nativeElement.click();
      }
    }));
  }
  addNoiseCatalogToWatchlist(noisecatalogId, noiseCatalogDisplayNumber) {
    //Analytics call
    this.analyticsService.trackSavedContentByTypeLineMake('Noise Catalog', noiseCatalogDisplayNumber, 'saved');
    //Analytics call
    this.noiseCatalogService.addNoiseCatalogToWatchlist(this.username, noisecatalogId).subscribe(data => {
      if (data) {
        this.toastService.success('Noise Catalog added to watchlist', 'Success', {
          closeButton: true,
          disableTimeOut: false,
          positionClass: 'toast-top-right',
          progressBar: true,
        })
      }
    });
  }
  noisecatalogshareContent(noiseCatalogId, type, mainGroup, noiseCatalogDisplayNumber) {
    this.noisecatalogshareContentObject = {
      noiseCatalogId: noiseCatalogId,
      type: type,
      mainGroup: mainGroup,
      noiseCatalogDisplayNumber: noiseCatalogDisplayNumber
    };
  }

}
